/* eslint-disable no-unused-vars */
/** @module Auth0PostLoginHandlerIos */
/* eslint-disable import/extensions */
import Auth0PostLoginHandlerBase from '../auth0-post-login-handler-base.mst.mjs';
import Auth0UserSessionHelper from '../../../../utils/auth0-session-helper.mjs';
import Auth0UtilsBrowser from '../../../../utils/auth0-utils-browser.mjs';
import Auth0TokenStorageHelper from '../auth0-token-storage-helper.mjs';

class Auth0PostLoginHandlerIos extends Auth0PostLoginHandlerBase {
  constructor(options) {
    super(options);
    this._options = options;
  }

  _shouldHandleSync = (loginData) => {
    return this._options.clientId === 'asDWgfdzraaKVBDxb69F5Zkmwvw5AvgP';
  };

  /**
   * @inheritdoc
   */
  async shouldHandle(loginData) {
    return Promise.resolve(this._shouldHandleSync(loginData));
  }

  /**
   * @inheritdoc
   */
  async run(loginData) {
    // Store tokens in the default locations (legacy _lat and _latv3 cookies)
    // This ensures tokens are available for the session helper and future requests
    if (loginData.tokens) {
      Auth0TokenStorageHelper.storeTokensDefault(loginData.tokens);
    }

    // the native part of the iOS app will be listening for this event that we will fire post login
    // This namespace is only present in iOS WkWebView and not in the browser
    // iOS is listening on custom message handler named "authHandler"
    // Prefer tokens from loginData if available, fall back to session helper
    const tokens = {
      access_token: loginData.tokens?.accessToken || Auth0UserSessionHelper.userAccessToken,
      refresh_token: loginData.tokens?.refreshToken || Auth0UserSessionHelper.userRefreshToken,
      id_token: Auth0UserSessionHelper.userIdentityToken,
    };
    console.log('Auth0PostLoginHandlerIos: Sending tokens to iOS native app', tokens);

    try {
      window.webkit.messageHandlers.authHandler.postMessage(tokens);
      console.log('Auth0PostLoginHandlerIos: Sent message to iOS native app; native app should hide the webview and show the native app');
    } catch (error) {
      const troubleshootingData = {
        userAgent: navigator?.userAgent,
        isStandalone: navigator?.standalone,
        isStandaloneEval: !('standalone' in navigator && navigator?.standalone),
        isSafariBrowserEval: /Safari/i.test(navigator?.userAgent),
        hasWebKitProp: !!window.webkit,
        isIosDevice: Auth0UtilsBrowser.isIosDevice,
        isIosWebView: Auth0UtilsBrowser.isIosWebView,
      };
      const troubleshootingDataString = JSON.stringify(troubleshootingData, null, 2);
      console.log('Auth0PostLoginHandlerIos: No window.webkit object found, not in iOS WkWebView =>', troubleshootingDataString);
      document.body.innerHTML = `In a genuine iOS WkWebView, we would have fired a successful login event into the native app<p>Issue: ${error.message}<p>If this is showing in the SS app inside a WkWebView, then it is a BUG. Here is the info you need to fix it:<p><pre><code>${troubleshootingDataString}</code></pre>EVENT PAYLOAD:</p><p><code>${JSON.stringify(tokens, null, 2)}</code></p>`;
    }
  }
}

export default Auth0PostLoginHandlerIos;
